import type { UIMessage } from '@ai-sdk/react';
import AIChatMarkdown, { type AIChatMarkdownComponents, type AIChatMarkdownVariant } from '../AIChatMarkdown';
import { stripAssistantPromptMetadata } from '../AIEntityMentionsInput.utils';
import { type ChatMessagePart, stripAssistantProgressPreamble } from './utils';

type Props = {
  components?: AIChatMarkdownComponents;
  isStreaming: boolean;
  messageRole: UIMessage['role'];
  part: Extract<ChatMessagePart, { type: 'text' }>;
  variant: AIChatMarkdownVariant;
};

const TextMessagePart = ({ components, isStreaming, messageRole, part, variant }: Props) => {
  const text = messageRole === 'user' ? stripAssistantPromptMetadata(part.text) : stripAssistantProgressPreamble(part.text);

  if (!text) return null;

  return (
    <AIChatMarkdown isAnimating={isStreaming} variant={variant} components={components}>
      {text}
    </AIChatMarkdown>
  );
};

export default TextMessagePart;
